$(document).ready(function() {
	$('.hp-gallery').lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.gallery-item-hp'
	});


	function add() {
    $(items[i]).addClass('gallery-item-hp');
    $(items[i]).find('.gallery-item-hp__img').attr('src', $(items[i]).attr('data-src-long'));
    
	}

	var items = $('.hp-gallery').children();
	var long1 = 1;
	var long2 = 3;
	var long3 = 8;
	var step = 9;

	for (var i = 0; i < items.length; i++) {
		switch (i) {
			case long1:
				add();
				long1 += step;
				break;
			case long2:
				add();
				long2 += step;
				break;
			case long3:
				add();
				long3 += step;
				break;
		}
	}
})

$(function() {

  var dirRtlFlag = false;
  if ($("html").attr('dir') == 'rtl') {
    dirRtlFlag = true;
  }
$('.hp-gallery').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 6000,
  rtl: dirRtlFlag,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
  {
      breakpoint: 1100,
      settings: {
      slidesToShow: 4,
      slidesToScroll: 1
      }
  },
  {
    breakpoint: 800,
    settings: {
    slidesToShow: 3,
    slidesToScroll: 1
    }
},
{
  breakpoint: 480,
  settings: {
  slidesToShow: 2,
  slidesToScroll: 1
  }
},
  // You can unslick at a given breakpoint now by adding:
  // settings: "unslick"
  // instead of a settings object
  ]
});
});